export const driversHeaderItems = [
  "driver ref ",
  "name",
  "trips",
  "last payout",
  "invitation status",
];
